export function getApiBaseUrl() {
  const raw = import.meta.env.VITE_API_URL?.trim();
  if (!raw) return "/api";
  if (raw.startsWith("/")) {
    const p = raw.replace(/\/+$/, "");
    return p || "/api";
  }
  try {
    const u = new URL(raw);
    const path = (u.pathname || "").replace(/\/+$/, "") || "";
    if (path === "" || path === "/") {
      return `${u.origin}/api`;
    }
    return raw.replace(/\/+$/, "");
  } catch {
    return raw.replace(/\/+$/, "");
  }
}
